import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, Button, Text } from '@pancakeswap-libs/uikit'
import { useWeb3React } from '@web3-react/core'


const StyledFarmStakingCard = styled(Card)`

`

const Block = styled.div`
  margin-bottom: 16px;
`

const CardImage = styled.img`
  margin-bottom: 16px;
`

const Label = styled.div`
  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 14px;
`

const Actions = styled.div`
  margin-top: 24px;
`

const FarmedStakingCard = () => {
  return (
    <StyledFarmStakingCard className="white_box vision_card_panel mt-5 carousel_card">
      <CardBody>
        <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active carousel_item_one">
              <div className="row">
                <div className="col-md-4">
                  <img src="/images/banner_img_02.png" alt="Slider" />
                </div>
                <div className="col-md-8">
                  <div className="carousel_content">
                    <h2>A PROUD PRODUCT FROM SURINAME</h2>
                    <p>panKUKU offers more products than any other DEX on the Market.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item carousel_item_two">
              <div className="row">
                <div className="col-md-4">
                  <img src="/images/banner_img_03.png" alt="Slider" />
                </div>
                <div className="col-md-8">
                  <div className="carousel_content">
                    <h2>PANKUKU REWARDS</h2>
                    <p>For every Transfer and Sell action, 1% is reserved for distribution between holders. <b>Holders are Rewarded</b> by their market share. The more KUKU you have, the more you get rewarded.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item carousel_item_three">
              <div className="row">
                <div className="col-md-4">
                  <img src="/images/banner_img_04.png" alt="Slider" />
                </div>
                <div className="col-md-8">
                  <div className="carousel_content">                  
                    <h2>What separates us from Other DEX</h2>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>No Minting of new tokens</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>A superb Burn System (automated & manual)</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>Anti-Whale Function</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>Automated Rewards to holders</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>An Eco System with expansive functions and products</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>A Utility Token to pay on our own Webshop</p>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="/images/tick_icon.png" alt="Slider" style={{width:"13px", marginRight: "8px", marginLeft: 0}} />
                      <p>High Level Security Infrastructure</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item carousel_item_four">
              <div className="row">
                <div className="col-md-4">
                  <img src="/images/banner_img_05.png" alt="Slider" />
                </div>
                <div className="col-md-8">
                  <div className="carousel_content">   
                    <h2>Deflationary Token</h2>                 
                    <p>panKUKU is a Deflationary Token, meaning we apply a <b>Tax System</b> to always push the price up by burning.</p>
                    <p>In return we contribute and fund our <b>charity foundation</b>.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="#carouselExampleCaptions" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleCaptions" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="sr-only">Next</span>
          </a>
        </div>
      </CardBody>
    </StyledFarmStakingCard>
  )
}

export default FarmedStakingCard
